import { useEffect, useState } from 'react';
import useFetchProductData from '../../hooks/ useFetchProductData/ useFetchProductData';
import { ProductIdType } from '../../types';
import CardList from '../CardList/CardList';
import CardListLoader from '../CardList/CardListLoader';

type AppProps = {
  productsId: ProductIdType[];
};

function App({ productsId }: AppProps) {
  const [isLoading, setIsLoading] = useState(true);
  const data = useFetchProductData(productsId);

  useEffect(() => {
    data && setIsLoading(false);
  }, [data]);

  return isLoading ? (
    <div className="m-section">
      <div className="m-section__container _container">
       <CardListLoader />
      </div>
    </div>
  ) : (
    <div className="m-section">
      <div className="m-section__container _container">
        {data && <CardList products={data} />}
      </div>
    </div>
  );
}

export default App;

// const arr = [];

// for (let i = 1; i <= 100; i++) {
//   arr.push(i);
// }

// const binarySearch = (list: number[], item: number): number | null => {
//   let low = 0;
//   let high = list[list.length - 1];

//   while (low <= high) {
//     const mid = Math.trunc((high + low) / 2);

//     if (list[mid] === item) {
//       return mid;
//     }

//     if (list[mid] <= item) {
//       low = mid + 1;
//     } else {
//       high = mid - 1;
//     }
//   }

//   return null;
// };

// console.log(binarySearch(arr, (2)));
